import React from "react";
import { Col, Input, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Flex } from 'antd-mobile';
import { debounce } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { digitalMenuSearchSetter, showDishesFilterModal } from '../../../../../redux/actions';
import Modal from '../Modal';
import DishesFilter from "./DishesFilter";
import { sendEvent } from '../../../../../utils/amplitude';


function TopMenu(props) {
  const dispatch = useDispatch();
  const restaurantName = useSelector(state => state.companyConfig.name);
  const companyId = useSelector(state => state.companyConfig.company_id);
  const amplId = useSelector(state => state.companyConfig.amplId);
  const verticalId = useSelector(state => state.companyConfig.vertical_id);

  const doSearch = (e) => {
    const func = debounce((value) => {
      dispatch(digitalMenuSearchSetter(value));
    }, 500);
    func(e.target.value);
  };

  const showFilterModal = () => {
    dispatch(showDishesFilterModal(true));
    sendEvent(amplId, 'Filters_Clicked', {
      'customer': restaurantName,
      'customerId': companyId,
      'vertical': verticalId,
      'page': 'filters',
    });
  };

  const closeFilterModal = () => {
    dispatch(showDishesFilterModal(false));
  };

  return (
    <Flex className="top-menu">
      <Modal reduxOpenState="digitalMenuConfig.showFilterModal" close={closeFilterModal}>
        <DishesFilter />
      </Modal>
      {/* <Flex.Item className="text-left m-l-12">Language</Flex.Item> */}
      <Flex.Item>
        <Row>
          <Col md={0} lg={6}></Col>
          <Col xs={24} lg={12}>
            <Row align="middle">
              <Col xs={22}>
                <Flex.Item style={{flex: "1 1 57%"}}>
                  <Input
                    bordered={false}
                    type="text"
                    placeholder="Suchen"
                    prefix={<SearchOutlined />}
                    onChange={(e) => doSearch(e)}
                  />
                </Flex.Item>
              </Col>
              <Col xs={2}>
                {
                  (verticalId === 3) &&
                  <Flex.Item className="text-right m-r-12 pointer" onClick={showFilterModal}>Filter</Flex.Item>
                }
              </Col>
            </Row>
          </Col>
          <Col md={0} lg={6}></Col>
        </Row>
      </Flex.Item>
    </Flex>
  );
}

export default TopMenu;
